import React, { useMemo } from 'react';
import { useHandleScreenResize } from '../../hooks/app/useHandleScreenResize';
import { useFetchNews } from '../../hooks/news/useFetchNews';
import NewsCards from '../Cards/NewsCards';

function NewsTeaserCards({ cssClasses = '' }) {
  const { news } = useFetchNews();
  const { isMobile } = useHandleScreenResize();

  // Memoize the sliced news array
  const slicedNews = useMemo(() => news?.slice(0, 6), [news]);

  // Early return if no news
  if (!news || news.length === 0) return null;

  return (
    <div className={cssClasses}>
      {/* News Headline with Link mobile+desktop */}
      <div className={!isMobile ? 'w-desktop--center pt-0' : ''}>
        <h2 className="mb-200rem mt-0 text-center--mobile">Meine News</h2>
      </div>

      <NewsCards news={slicedNews} carousel={true} />
    </div>
  );
}

export default React.memo(NewsTeaserCards);
